import { render, staticRenderFns } from "./regulationsystem.vue?vue&type=template&id=d0280fce&"
import script from "./regulationsystem.vue?vue&type=script&lang=js&"
export * from "./regulationsystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports